import { render, staticRenderFns } from "./SelectStartupsModal.vue?vue&type=template&id=af0e5c84&scoped=true&"
import script from "./SelectStartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./SelectStartupsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0e5c84",
  null
  
)

export default component.exports